import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { EmplacementService } from '../../services/emplacement-service';
import { AchatService } from '../../services/achat-service';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CodeProjetEntite } from 'src/app/entites/code-projet';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { CleValeur } from 'src/app/entites/cleValeur';
import { EmplacementAdresseEntite } from 'src/app/entites/emplacement-adresse-entite';
import { AdresseEntite } from 'src/app/entites/adresse';

@Component({
    templateUrl: './ajout-achat.component.html',
    styleUrls: ['./ajout-achat.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class AjoutAchatComponent extends BaseComponent implements OnInit {


    fournisseurs: Fournisseur[];
    selectionFournisseur: Fournisseur;

    dateBonCommande: Date;
    requisLe: Date;
    note: string;

    listeCodeProjet: CodeProjetEntite[];
    selectionCodeProjet: CodeProjetEntite;

    selectedEmplacementId: number = 10000;
    selectedAddress: AdresseEntite;

    listeTypeBdc: CleValeur[];
    typeBdc: CleValeur;

    frequences: CleValeur[];
    selectionFrequence: CleValeur;

    submitted: boolean = false;

    menu: MenuItem[];

    creerRequisition: boolean = false;
    raison: string;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private achatService: AchatService,
        private fournisseurService: FournisseurService,
        private emplacementService: EmplacementService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Bons de commande', routerLink: '/achats' },
            { label: 'Ajouter' }
        ]);
    }

    ngOnInit() {

        this.verifierAccesPage('bdc_creer');

        this.dateBonCommande = new Date();

        this.listeCodeProjet = this.sdb.CodesProjet();

        if (this.profilService.Profil().roles.filter(x => x.nom == 'SIHC_ChargeProjet').length > 0) {
            this.listeTypeBdc = [
                { cle: 'BCA', valeur: 'BCA' },
                { cle: 'BCS', valeur: 'BCS' }
            ]
        } else {
            this.listeTypeBdc = [
                { cle: 'BCF', valeur: 'BCF' },
                { cle: 'BCS', valeur: 'BCS' }
            ]
            this.typeBdc = this.listeTypeBdc[0];
        }

        this.menu = [
            {
                label: 'Retour',
                icon: 'pi pi-fw pi-angle-double-left',
                command: () => window.history.back(),
            }
        ]

        this.frequences = [
            { cle: 'N', valeur: 'Aucune' },
            { cle: 'J', valeur: 'Jours' },
            { cle: 'H', valeur: 'Semaine' },
            { cle: 'M', valeur: 'Mois' },
            { cle: 'A', valeur: 'Année' },
            { cle: 'D', valeur: 'Détaillée' }
        ]
        this.selectionFrequence = this.frequences[0];

        var p1 = new Promise<number>((resolve, reject) => {
            this.fournisseurService.ObtenirFournisseurs().then(x => {
                this.fournisseurs = x.valeur;
                resolve(null);
            });
        });

        Promise.all([p1]).then(x => {
            this.CompleterChargement();
        });
    }

    CreerBdc() {
        this.submitted = true;
        this.messageService.clear();

        if (this.valider()) {

            this.DemarrerChargement();

            this.achatService.CreerBonCommande({
                fournisseur: this.selectionFournisseur,
                dateAchat: this.dateBonCommande,
                projet: this.selectionCodeProjet,
                employe: this.profilService.ProfilCourant(),
                emplacement: this.sdb.Emplacement(this.selectedEmplacementId),
                adresse: this.selectedAddress?.adresseId == null ? null : this.selectedAddress,
                note: this.note,
                typeBonCommande: this.typeBdc.cle,
                frequence: this.selectionFrequence?.cle,
                requisLe: this.requisLe,
                creerRequisition: this.creerRequisition,
                raisonFournisseur: this.raison
            }).then(x => {
                if (x.estUnSucces) {
                    this.achatService.ClearCacheBonsCommande();
                    this.routerService.navigateByUrl('achat/' + x.valeur);
                } else {
                    x.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                    });

                    this.CompleterChargement();
                }
            });
        } else {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Veuillez corriger les erreurs avant de continuer.', sticky: true });
        }
    }

    surChangementFrequence() {
        this.creerRequisition = this.selectionFrequence.cle != 'N' ? false : this.creerRequisition;
    }

    surChangementFournisseur() {
        if (this.fournisseurService.getQualityScore(this.selectionFournisseur) == 'danger') {
            this.confirmationService.confirm({
                key: 'confirm-bad-supplier',
                message: 'Ce fournisseur a une note de qualité trop basse. Veuillez indiquer la raison de choisir ce fournisseur.',
                acceptLabel: 'Continuer',
                rejectLabel: 'Annuler',
                reject: () => {
                    this.raison = null;
                    this.selectionFournisseur = null;
                }


            });
        }
        this.raison = null;
    }

    valider(): boolean {


        if (!this.selectionFournisseur || !this.dateBonCommande || !this.selectionCodeProjet || !this.typeBdc) {
            return false;
        }

        return true;
    }
}
